<template>
  <div
    class="daySelect"
    :style="{ justifyContent: isEnd ? 'flex-end' : 'flex-start' }">
    <div
      v-for="(day, index) in dayListData"
      :key="index"
      class="dayItem"
      :class="dayNowData == day.value ? 'cheaked' : ''">
      <div @click="daySelectChange(day, index)">
        {{ day.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    dayNow: {
      type: [Number, String],
      default: 1,
    },
    dayList: {
      type: Array,
    },
    isEnd:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dayNowData: "",
      dayListData: [],
      startTime: "",
      endTime: "",
    };
  },
  computed: {},
  watch: {
    dayNow: {
      immediate: true,
      handler(val) {
        this.dayNowData = val;
      },
    },
    dayList: {
      immediate: true,
      handler(val) {
        this.dayListData = val;
      },
    },
  },
  created() {},
  mounted() {
    console.log(this.dayList);
  },
  methods: {
    daySelectChange(item, index) {
      this.dayNowData = item.value;
      this.recent_time(item.value);
      // 0-今天，7-近7天，30-近30天，365-近1年
      this.$emit("outDay", Number(this.dayNowData));
      this.$emit("outDayList", [this.startTime, this.endTime]);
    },
    recent_time(i) {
      // 0-今天，1-昨天，7-近7天，30-近30天，365-近1年
      if (i == 1) {
        this.startTime = this.getDay(-1, "-");
        this.endTime = this.getDay(-1, "-");
      } else if (i == 7) {
        this.startTime = this.getDay(-7, "-");
        this.endTime = this.getDay(0, "-");
      } else if (i == 15) {
        this.startTime = this.getDay(-15, "-");
        this.endTime = this.getDay(-1, "-");
      } else if (i == 30) {
        this.startTime = this.getDay(-30, "-");
        this.endTime = this.getDay(0, "-");
      } else if (i == 0) {
        this.startTime = this.getDay(0, "-");
        this.endTime = this.getDay(0, "-");
      } else if (i == 365) {
        this.startTime = this.getDay(-365, "-");
        this.endTime = this.getDay(0, "-");
      }
    },
    getDay(num, separator) {
      const today = new Date();
      const nowTime = today.getTime();
      const ms = 24 * 3600 * 1000 * num;
      today.setTime(parseInt(nowTime + ms));
      const oYear = today.getFullYear();
      let oMoth = (today.getMonth() + 1).toString();
      if (oMoth.length <= 1) oMoth = "0" + oMoth;
      let oDay = today.getDate().toString();
      if (oDay.length <= 1) oDay = "0" + oDay;
      return oYear + separator + oMoth + separator + oDay;
    },
  },
};
</script>

<style lang="scss" scoped>
.daySelect {
  display: flex;
  flex-flow: wrap;
  // justify-content: flex-end;
  .dayItem {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    padding: 6px 12px;
    font-weight: 400;
    font-size: 14px;
    color: #666;
    text-align: center;
    height: 30px;
    cursor: pointer;
    box-sizing: border-box;
        margin-right: 6px;
        border-radius: 4px;
    div {
      font-family: PingFangSC Medium;
    }
  }

  .dayItem:first-child {
    // border-radius: 4px 0px 0px 4px;
  }
  .dayItem:nth-child(2) {
    // border-left-color: #ffffff;
    // border-right-color: #ffffff;
  }
  .dayItem:last-child {
    // border-radius: 0px 4px 4px 0px;
  }
  .dayItem.cheaked {
    // font-weight: 500;
    font-size: 14px;
    color: $theme-color;
    border-color: $theme-color;
  }
  .dayItem.cheaked:nth-child(2) {
    // border-left-width: 1px;
    // border-right-width: 1px;
    .dayItem:first-child {
      border-left-color: #ffffff;
    }
    .dayItem:last-child {
      border-right-color: #ffffff;
    }
  }

  .dayItem:hover {
    // color: $theme-color;
  }
}
</style>
